import { gql } from '@apollo/client'

export const GET_DEFAULT_WATCHLIST = gql`
  query getDefaultWatchList {
    getMyDefaultWatchList {
      id
      items(first: 100) {
        edges {
          node {
            id
            content {
              __typename
              ... on ContentDisplayable {
                id
                imageLandscape: image(category: ANGEL_KEY_ART_1, aspect: "16:9") {
                  cloudinaryPath
                }
                imagePortrait: image(category: ANGEL_KEY_ART_1, aspect: "2:3") {
                  cloudinaryPath
                }
                name
                description(version: SHORT)
              }
              ... on ContentSeries {
                id
                project {
                  id
                  slug
                }
              }
              ... on ContentSpecial {
                id
                project {
                  id
                  slug
                }
              }
              ... on ContentMovie {
                id
                project {
                  id
                  slug
                }
              }
            }
          }
        }
      }
    }
  }
`

export const GET_ONBOARDING_WATCHLIST = gql`
  query getOnboardingWatchList {
    getMyDefaultWatchList {
      id
      items(first: 100) {
        edges {
          node {
            id
            content {
              __typename
              ... on ContentDisplayable {
                id
                name
                genres
                ratings
                longDescription: description(version: LONG)
                mediumDescription: description(version: MEDIUM)
                shortDescription: description(version: SHORT)
                angelKeyArt1: image(aspect: "2:3", category: ANGEL_KEY_ART_1) {
                  cloudinaryPath
                }
                angelKeyArt2: image(aspect: "2:3", category: ANGEL_KEY_ART_2) {
                  cloudinaryPath
                }
                angelKeyArt3: image(aspect: "2:3", category: ANGEL_KEY_ART_3) {
                  cloudinaryPath
                }
                still1: image(aspect: "16:9", category: STILL_1) {
                  cloudinaryPath
                }
                still2: image(aspect: "16:9", category: STILL_2) {
                  cloudinaryPath
                }
                still3: image(aspect: "16:9", category: STILL_3) {
                  cloudinaryPath
                }
                nonTitleArt: image(aspect: "16:9", category: NON_TITLE_ART) {
                  cloudinaryPath
                }
                nonTitleArtMobile: image(aspect: "4:3", category: NON_TITLE_ART) {
                  cloudinaryPath
                }
                backdrop: image(aspect: "16:9", category: BACKDROP) {
                  cloudinaryPath
                }
                logo: image(aspect: "9:5", category: LOGO) {
                  cloudinaryPath
                }
              }
              ... on ContentMovie {
                id
                __typename
                originalReleaseDate
                preview {
                  id
                  m3u8Uri
                  duration
                }
                project {
                  id
                  slug
                  highestScore
                  primaryFlowPhases {
                    phaseSlugEnum
                    status
                    releaseWindows {
                      start
                    }
                  }
                  title {
                    __typename
                    ... on Node {
                      id
                    }
                    ... on ContentSharable {
                      isGuildShareAvailable
                    }
                  }
                }
              }
              ... on ContentSpecial {
                id
                __typename
                originalReleaseDate
                preview {
                  id
                  m3u8Uri
                  duration
                }
                project {
                  id
                  slug
                  highestScore
                  primaryFlowPhases {
                    phaseSlugEnum
                    status
                    releaseWindows {
                      start
                    }
                  }
                  title {
                    __typename
                    ... on Node {
                      id
                    }
                    ... on ContentSharable {
                      isGuildShareAvailable
                    }
                  }
                }
              }
              ... on ContentSeries {
                id
                __typename
                originalReleaseDate
                preview {
                  id
                  m3u8Uri
                  duration
                }
                firstWatchable {
                  __typename
                  ... on ContentEpisode {
                    id
                    watchableAvailabilityStatus
                    episodeNumber
                    season {
                      id
                      seasonNumber
                    }
                  }
                }
                project {
                  id
                  slug
                  highestScore
                  primaryFlowPhases {
                    phaseSlugEnum
                    status
                    releaseWindows {
                      start
                    }
                  }
                  title {
                    __typename
                    ... on Node {
                      id
                    }
                    ... on ContentSharable {
                      isGuildShareAvailable
                    }
                  }
                }
              }
              ... on ContentSharable {
                isGuildShareAvailable
              }
              ... on ContentWatchable {
                duration
                watchPosition {
                  position
                }
              }
              ... on ContentWatchableAvailability {
                watchableAvailabilityStatus
                actionsToWatch {
                  __typename
                }
                watchableReasons {
                  __typename
                  ... on LinkshareAvailabilityAction {
                    startDatetime
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`

export const CONTENT_IN_WATCHLIST = gql`
  query getContentInWatchList($contentId: String!) {
    contentInWatchList(contentId: $contentId) {
      id
      content {
        __typename
        ... on ContentDisplayable {
          id
        }
      }
    }
  }
`

export const ADD_TO_WATCHLIST = gql`
  mutation addToWatchList($contentId: String!) {
    addToWatchList(contentId: $contentId) {
      id
    }
  }
`

export const DELETE_FROM_WATCHLIST = gql`
  mutation deleteFromWatchList($contentId: String!) {
    deleteFromWatchList(contentId: $contentId) {
      id
    }
  }
`
